module.exports = __webpack_public_path__ + "img/xunxiang-banner.69c362c3.png";